// frontend/src/lib/marcasEnVuelo.ts
// Contador global de marcas "en vuelo": acciones de presentismo que el usuario ya
// inició (cuenta regresiva de CadeteCard, espera de geolocalización) pero que
// todavía NO están escritas en IndexedDB. Mientras sea > 0, recargar la app
// (auto-actualización) o cerrar sesión perdería esas marcas.

let enVuelo = 0;
const listeners = new Set<() => void>();

const notificar = () => {
  listeners.forEach((fn) => {
    try { fn(); } catch { /* noop */ }
  });
};

/**
 * Registra una marca en vuelo. Devuelve una función de liberación idempotente:
 * llamarla más de una vez no descuenta de más.
 */
export function iniciarMarcaEnVuelo(): () => void {
  enVuelo++;
  notificar();
  let liberada = false;
  return () => {
    if (liberada) return;
    liberada = true;
    enVuelo = Math.max(0, enVuelo - 1);
    notificar();
  };
}

export function getMarcasEnVuelo(): number {
  return enVuelo;
}

/**
 * Suscribe a los cambios del contador (inicio y fin de cada marca en vuelo).
 * Devuelve la función para desuscribirse. Lo usa BannerApp para ocultarse
 * mientras haya marcas en vuelo.
 */
export function suscribirMarcasEnVuelo(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/**
 * Espera a que no queden marcas en vuelo (o a que venza el timeout).
 * Devuelve true si el contador llegó a 0.
 */
export function esperarMarcasEnVuelo(timeoutMs = 8000): Promise<boolean> {
  if (enVuelo === 0) return Promise.resolve(true);
  return new Promise((resolve) => {
    const check = () => {
      if (enVuelo === 0) {
        clearTimeout(timer);
        listeners.delete(check);
        resolve(true);
      }
    };
    const timer = setTimeout(() => {
      listeners.delete(check);
      resolve(enVuelo === 0);
    }, timeoutMs);
    listeners.add(check);
  });
}

/** Pide a las tarjetas con cuenta regresiva que confirmen YA su marca. */
export const FLUSH_MARCAS_EVENT = 'sgcc:flush-marcas-en-vuelo';

export function solicitarFlushMarcas(): void {
  window.dispatchEvent(new CustomEvent(FLUSH_MARCAS_EVENT));
}
